import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useGetCustomersWithoutActivity } from "../../hooks/useCrm";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import Loading from "../Loadings/LoadingTable";
import { Table } from "../Table/Table";
import { CusStyle } from "./CustomersWithoutActivityStyle";

export const CustomersWithoutActivity = () => {
  const { data, isLoading } = useGetCustomersWithoutActivity();
  const [Search, setSearch] = useState("");

  const headerTitle = [
    "ردیف",
    "نام و نام خانوادگی",
    "نام و نام خانوادگی مسئول",
    "تاریخ ثبت نام",
  ];
  let house = 0;
  let store = 0;
  const items = data?.data?.File?.filter((user) => {
    const name = user.split("x:");
    if (Search === "") {
      return user;
    } else if (name[2].includes(Search)) {
      return user;
    } else if (name[3].includes(Search)) {
      return user;
    }
  }).map((item, index) => {
    const name = item.split("x:");

    if (
      name[3] !== "مشتریان خانگی" &&
      name[3] !== "پرونده بچگانه" &&
      name[3] !== "پرونده لباس زیر"
    ) {
      store++;
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {store}
            </span>
          </td>
          <td>
            <Link to={`/dashboard/crm/customer-file/${name[1]}`}>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {name[2]}
              </span>
            </Link>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {name[3]}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {MiladiToShamsi(name[4])}
            </span>
          </td>
        </tr>
      );
    }
  });

  const houseItems = data?.data?.File?.filter((user) => {
    const name = user.split("x:");
    if (Search === "") {
      return user;
    } else if (name[2].includes(Search)) {
      return user;
    } else if (name[3].includes(Search)) {
      return user;
    }
  }).map((item, index) => {
    const name = item.split("x:");

    if (
      name[3] === "مشتریان خانگی" ||
      name[3] == "پرونده بچگانه" ||
      name[3] == "پرونده لباس زیر"
    ) {
      house++;
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {house}
            </span>
          </td>
          <td>
            <Link to={`/dashboard/crm/customer-file/${name[1]}`}>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {name[2]}
              </span>
            </Link>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {name[3]}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {MiladiToShamsi(name[4])}
            </span>
          </td>
        </tr>
      );
    }
  });
  return (
    <CusStyle className="mt-3">
      <BreadCrumb
        margin="mt-3"
        num1="واحد CRM"
        num2="گزارشگیری"
        num3="مشتری های بدون فعالیت"
        href1="/dashboard/crm"
        href2="/dashboard/crm/reporting"
      />
      <Tabs
        defaultActiveKey="home"
        transition={false}
        id="noanim-tab-example"
        className="mb-3"
      >
        <Tab eventKey="home" title="مغازه">
          {isLoading ? (
            <Loading />
          ) : (
            <Table
              headerTitle={headerTitle}
              title={`مشتری های بدون فعالیت ${store}`}
              items={items}
              setSearch={setSearch}
            />
          )}
        </Tab>
        <Tab eventKey="profile" title="خانگی">
          {isLoading ? (
            <Loading />
          ) : (
            <Table
              headerTitle={headerTitle}
              title={`مشتری های بدون فعالیت ${house}`}
              items={houseItems}
              setSearch={setSearch}
            />
          )}
        </Tab>
      </Tabs>
    </CusStyle>
  );
};
